<template>
  <div class="homeMap">
    <div class="homeMap-map" id="homeMap-map"></div>
    <div class="search" v-show="isActive === 0" style="flex-direction: column;">

      <div style="margin-bottom: 12px;">
        <!-- <span style="font-size: 14px;color:#d7e9f2;margin-right: 14px;">动力方式</span> -->
        <el-select v-model="protocalType" placeholder="" @change="changePowerMode">
          <el-option v-for="item in PowerOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <br>
      </div>
      <div style="display: flex;">
        <el-select v-model="value" placeholder="">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <span class="search-input">
        <el-input @focus="showList = true" @blur="showList = false" v-model="input" placeholder=""></el-input>
      </span>
        <el-button size="small"
                   :disabled="queryDisable"
                   @click="search(value, input)">查询</el-button>
      </div>

      <transition name="fade">
        <div v-show="showList && carList[0]" class="searchList">
          <ul>
            <li @click="input = item" v-for="(item, index) of carList" :key="index">{{item}}</li>
          </ul>
        </div>
      </transition>
    </div>
    <div class="search" v-show="isActive === 1">
      <el-select v-model="govNow1" placeholder="">
        <el-option v-for="item in govList1" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="search" v-show="isActive === 2">
      <el-select v-model="govNow2" placeholder="">
        <el-option v-for="item in govList2" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <!-- <div v-show="isActive === 0" >
      <div class="search"
        style="position: absolute;width: 4rem;left: auto;display: flex; top: 3rem;right: .5rem;flex-direction: column;
        font-size: 0.28rem;">
        <div style="background: #19738eb8; border: 1px solid #04c4de;padding: 0.2rem;">
          <div>
            <h3>地区: <b>西藏</b></h3>
          </div>
          <div>
            <span>车辆：20台</span>
            <span>运输任务数: 10</span>
          </div>
        </div>
        <br>
        <div style="background: #19738eb8; border: 1px solid #04c4de;padding: 0.2rem;">
          <div>
            <h3>地区: <b>新疆</b></h3>
          </div>
          <div>
            <span>车辆：20台</span>
            <span>货物：子弹20箱</span>
          </div>
        </div>
        <br>
        <div style="background: #19738eb8; border: 1px solid #04c4de;padding: 0.2rem;">
          <div>
            <h3>地区: <b>浙江</b></h3>
          </div>
          <div>
            <span>车辆：123台</span>
            <span>货物：子弹2023箱</span>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 暂时隐藏 -->
    <!-- <div style="left: 0.2rem;position: absolute;bottom: 0.2rem;right: auto;top: auto;display: none;" v-show="isActive === 0" >
      <mapss style="width: 7rem; height: 2.5rem;" ></mapss>
    </div> -->

    <div class="u242" style="transform: rotate(0deg)" v-show="isActive === 0">
      <img src="https://d1icd6shlvmxi6.cloudfront.net/gsc/1EEB2C/d0/cd/06/d0cd066f52234812b52240958133f2e2/images/%E9%A6%96%E9%A1%B5/%E6%8C%87%E9%92%881_u242.svg?pageId=b93233f4-5768-457e-b909-6ae22d4571a5" alt="">
    </div>
    <!-- <div class="search" v-show="isActive === 4">
      <el-select v-model="govNow3" placeholder="">
        <el-option v-for="item in govList3" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div> -->
<!--    <div class="homeMap-data" v-show="isActive === 0">-->
<!--      <div class="homeMap-data-list" v-for="(item,index) in smallData" :key="index">-->
<!--        <span class="icon" :style="{'background':redColor[index]}"></span>-->
<!--        <span>{{item}}</span>-->
<!--      </div>-->
<!--    </div>-->
    <!-- 右上角的充电热力和轨迹热力 -->
    <div class="tab">
      <div v-for="(item,index) in 4"
           :class="['tab-small','icon'+index]"
           :key="index"
           @click="tab(index)"></div>
    </div>
  </div>
</template>

<script>
import map from './map/map'
// import mapss from './map/mapss.vue'
export default {
  // components: { mapss },
  mixins: [map],
  data () {
    return {
      options: [
        {
          value: '1',
          label: '车牌号'
        },
        {
          value: '2',
          label: 'VIN'
        }
      ],
      PowerOptions: [
        {
          value: '5',
          label: '纯电'
        },
        {
          value: '6',
          label: '传统燃油'
        },
        {
          value: '',
          label: '全部'
        }
      ],
      protocalType: '',
      showList: false,
      value: '1',
      input: '',
      smallData: ['车辆在线', '车辆充电', '车辆故障', '车辆离线'],
      redColor: ['#21D5AB', '#F3DA4F', '#FF0000 ', '#00C0FF'],
      isActive: 0
    }
  },
  methods: {
    tab (index) {
      this.isActive = index
      // 燃油车数据
      if (index === 3) {
        this.setHeatData(6)
      }
      if (index === 2) {
        this.setHeatData(5)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.homeMap {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  .search {
    position: absolute;
    top: 0.72rem;
    left: 0.54rem;
    display: flex;
  }
  .searchList {
    position: absolute;
    top: .7rem;
    left: 2.3rem;
    padding: .1rem;
    max-height: 7rem;
    background: rgba(39, 227, 255, 0.3);
    border: 0.01rem solid rgba(39, 227, 255, 0.45);
    overflow-y: auto;
    li {
      padding: .04rem .14rem;
      cursor: pointer;
      &:hover {
        background: rgba(39, 227, 255, 0.6);
      }
    }
  }
  .homeMap-data {
    position: absolute;
    bottom: 0.4rem;
    left: 0.54rem;
    height: 2.5rem;
    width: 2.2rem;
    background: url("../../../assets/images/home/mapData.png") no-repeat;
    padding: 0.2rem;
    box-sizing: border-box;
    background-size: 100% 100%;
    .homeMap-data-list {
      font-size: 0.26rem;
      color: #bdd3db;
      line-height: 0.55rem;
      text-align: center;
      span {
        display: inline-block;
      }
    }
    .icon {
      width: 0.2rem;
      height: 0.2rem;
      border-radius: 50%;
      margin-right: 0.2rem;
    }
  }
  .tab {
    display: flex;
    position: absolute;
    top: 0.72rem;
    right: 0.54rem;
    .tab-small {
      width: 0.92rem;
      height: 0.7rem;
      margin-left: 0.2rem;
      cursor: pointer;
    }
    @for $i from 0 through 3 {
      .icon#{$i} {
        background: url("../../../assets/images/home/small-0#{$i+1}.png")
          no-repeat;
        background-size: 100% 100%;
        &.active {
          //background: url("../../../assets/images/home/selected-0#{$i+1}.png")
          //  no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.homeMap {
  .el-select {
    width: 2.3rem;
    text-align: center;
  }
  .el-input__inner {
    width: 2.3rem;
    height: 0.7rem;
    line-height: 0.7rem;
    background: rgba(39, 227, 255, 0.3);
    border: 1px solid rgba(39, 227, 255, 0.45);
    font-size: 0.3rem;
    color: #d7e9f2;
    border-radius: 0;
  }
  .el-select .el-input .el-select__caret {
    line-height: 0.7rem;
  }
  .search-input {
    .el-input__inner {
      width: 3rem;
      border: 1px solid rgba(39, 227, 255, 0.45);
      background: rgba(39, 227, 255, 0.1);
      border-left: 0;
    }
  }

  .el-select-dropdown {
    width: 2.3rem;
  }
  .el-button {
    height: 0.7rem;
    line-height: 0.2rem;
    width: 1.5rem;
    border-radius: 0;
    background: rgb(29, 49, 52);
    border: 0.01rem solid rgba(39, 227, 255, 0.45);
    border-left: 0;
    color: #d7e9f2;
    font-size: 0.3rem;
  }
  .el-select:hover .el-input__inner {
    border: 1px solid rgba(39, 227, 255, 0.45);
  }
}
.el-select-dropdown__list {
  padding: 0.3rem 0 0.5rem 0;
}
.el-select-dropdown__item {
  height: 0.7rem;
  line-height: 0.7rem;
  font-size: 0.3rem;
}
.homeMap-map {
  height: calc(100vh);
}
.map_label {
  position: relative;
  // width: 1.63rem;
  // height: .92rem;
  width: 133px;
  height: 75px;
  font-size: 14px;
}
.map_lableImg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.map_labelCon {
  position: absolute;
  // padding-top: .14rem;
  padding-top: 11.4px;
  top: 0;
  left: 0;
  width: 100%;
}
.map_labelP {
  text-align: center;
  // line-height: .3rem;
  line-height: 24.5px;
}
.amap-info, .amap-markers {
  z-index: 1000 !important;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
::-webkit-scrollbar {
  width: 8px;
    background: rgba(39, 227, 255, 0.2);
}

::-webkit-scrollbar-track {
    background: rgba(39, 227, 255, 0.2);
}

::-webkit-scrollbar-thumb {
    background: rgba(39, 227, 255, 1);
}
.u242 {
  background: #19738e59;
  border-radius: 50%;
  border-width:0px;
  position:absolute;
  left:5rem;
  top:5rem;
  width:5rem;
  height:5rem;
  display:flex;
  color:#1E1E1E;
  transition: transform 2s ease-out 500ms;
  // transform: rotate(0deg);
  animation: circleround 2.5s infinite;
}
@keyframes circleround {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
</style>
